<template>
  <div class="root-container">
    <el-dialog
      title="家长购卡"
      :visible.sync="showDlg"
      width="50%"
      top="10vh"
      center
    >
      <el-form
        ref="registerRef"
        :model="createParam"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="选择卡:" prop="storeLessonCardId">
          <el-select
            v-model="createParam.storeLessonCardId"
            @change="onChangeStoreLesson"
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in storeLessonCards"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input
            v-model="createParam.userPhone"
            placeholder=""
            style="width: 270px"
          ></el-input>
          <el-button
            style="margin-left: 10px; margin-top: 5px"
            type="info"
            size="mini"
            @click="handleSearchUser()"
            >搜索</el-button
          >
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="家长信息:">
              <el-input
                v-model="createParam.user.name"
                disabled
                style="width: 270px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="额外赠送课时:">
              <el-input
                v-model="createParam.extGiveClassCount"
                style="width: 270px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="价格(元):">
              <el-input
                readonly="true"
                style="width: 270px"
                v-model="createParam.totalPay"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠金额(元):">
              <el-input
                style="width: 270px"
                v-model="createParam.givenPay"
                @input="rateRealPay()"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效天数:">
              <el-input
                readonly="true"
                style="width: 270px"
                v-model="createParam.cardTime"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实付金额(元):">
              <el-input
                readonly="true"
                style="width: 270px"
                v-model="createParam.realPay"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="总课时:">
              <el-input
                readonly="true"
                style="width: 270px"
                v-model="createParam.classCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="礼品:">
              <el-input
                style="width: 270px"
                v-model="createParam.gift"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="邀约人:">
          <el-select
            v-model="createParam.inviteWorker"
            clearable
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in allWorker"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成单人1:">
              <el-select
                v-model="createParam.buyCardWorker"
                clearable
                placeholder="请选择"
                style="width: 270px"
              >
                <el-option
                  v-for="item in allWorker"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成单人2:">
              <el-select
                v-model="createParam.buyCardWorkerTwo"
                clearable
                placeholder="请选择"
                style="width: 270px"
              >
                <el-option
                  v-for="item in allWorker"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="渠道:">
              <el-select
                v-model="createParam.source"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === '网络咨询(NI)'">
            <el-form-item label="二级渠道:">
              <el-select
                v-model="createParam.sourceTwo"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sourceTwoOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === '异业合作'">
            <el-form-item label="合作方:">
              <el-select
                v-model="createParam.sourceTwo"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in frontBizTypeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === 'Peferral转介绍'">
            <el-form-item label="介绍人手机号:">
              <el-input
                style="width: 270px"
                v-model="createParam.introducer"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注信息:">
          <el-input
            type="textarea"
            placeholder=""
            v-model="createParam.remark"
            maxlength="30"
            show-word-limit
            style="width: 450px"
          ></el-input>
        </el-form-item>
        <el-form-item label="音频文件：">
          <el-upload
            :action="uploadAction"
            :headers="importHeaders"
            :file-list="uploadFileList"
            :on-success="handleAudioUploadSuccess"
            :on-remove="handleAudioUploadRemove"
            accept=".mp3"
            :limit="3"
            list-type="file"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传mp3文件,数量限制为3
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer-1">
        <el-button @click="onBtnCancel()">取消</el-button>
        <el-button type="primary" @click="onBtnSure('registerRef')"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
  </div>
</template>

<style></style>

<script>
import globaldata from "../../../utils/globaldata";
import messageUtils from "../../../utils/messageUtils";
import commonUtils from "../../../utils/commonUtils";
import { createUserByCard } from "../../../api/userByCard";
import { findVipUser } from "../../../api/storeFront";
import WorkerWord from "../../../components/WorkerWord/WorkerWord";
import { frontBizTypeList } from "../../../api/frontBizType";
import { getStaticData } from "@/api/staticData";
import { getToken } from "@/utils/auth";
export default {
  components: { WorkerWord },
  name: "BuyLessonCardDetail",
  props: {
    show: Object,
    storeLessonCards: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      rules: {
        storeLessonCardId: [
          { required: true, message: "请选择卡", trigger: "blur" },
        ],
        cardTime: [
          { required: true, message: "请选择卡有效期", trigger: "blur" },
        ],
      },
      refreshWord: "",
      showDlg: false,
      showWordDlg: false,
      tData: null,
      wordType: 0,
      audioFileList: [],
      uploadFileList: [],
      createParam: {},
      allWorker: [],
      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],
      sourceTwoOptions: [
        { name: "美团" },
        { name: "大众点评" },
        { name: "官网" },
        { name: "其他" },
      ],
      frontBizTypeList: [],
      importHeaders: "",
      uploadAction: "",
    };
  },
  created() {
    this.showDlg = this.show;
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    this.initData();
    let mytoken = getToken();
    this.importHeaders = { Authorization: mytoken };
    let param = {
      storeFrontId: globaldata.getAdminStore().storeFrontId,
    };
    frontBizTypeList(param).then((response) => {
      this.frontBizTypeList = response.data;
    });

    getStaticData("").then((response) => {
      let data = response.data;
      if (commonUtils.isObjectNull(data)) {
        return;
      }
      this.uploadAction =
        data.uploadChildPhotoImageUrl + "/" + param.storeFrontId;
    });
  },
  methods: {
    rateRealPay() {
      this.createParam.realPay =
        this.createParam.totalPay - this.createParam.givenPay;
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    initData() {
      this.createParam = {
        cardTime: "",
        remark: "", //
        userPhone: "", //家长手机号
        totalPay: "", //家长支付金额
        user: {
          name: "",
        },
        classCount: 0,
        showWordDlg: this.show,
        options: [],
        storeLessonCardId: "",
        inviteWorker: null,
        buyCardWorker: null,
      };
    },
    onBtnSure(registerRef) {
      if (commonUtils.isStringNull(this.createParam.user.name)) {
        messageUtils.errorMsg(this, "没有找到家长信息");
        return;
      }

      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          let param = {
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            remark: this.createParam.remark,
            userId: this.createParam.user.id,
            totalPay: this.createParam.totalPay,
            cardStartTime: this.createParam.cardTime[0],
            cardEndTime: this.createParam.cardTime[1],
            storeLessonCardId: this.createParam.storeLessonCardId,
            inviteWorker: this.createParam.inviteWorker,
            buyCardWorker: this.createParam.buyCardWorker,
            buyCardWorkerTwo: this.createParam.buyCardWorkerTwo,
            source: this.createParam.source,
            sourceTwo: this.createParam.sourceTwo,
            introducer: this.createParam.introducer,
            realPay: this.createParam.realPay,
            givenPay: this.createParam.givenPay,
            gift: this.createParam.gift,
            extGiveClassCount: this.createParam.extGiveClassCount,
            adminWord: "",
            audioFileList: this.audioFileList,
          };
          this.tData = param;
          this.doRefreshWord(true, 1);
        } else {
          return false;
        }
      });
    },
    onBtnCancel() {
      this.closeWordDlg();
      this.showDlg = false;
      this.$emit("onBtnCancel");
    },

    onChangeStoreLesson(val) {
      for (let i = 0; i < this.storeLessonCards.length; ++i) {
        let card = this.storeLessonCards[i];
        if (card.id == val) {
          this.createParam.totalPay = card.valueMoney;
          this.createParam.cardTime = card.validDays;
          this.createParam.classCount =
            card.totalClassCount + card.giveClassCount;
          this.createParam.totalGiveCount = card.giveClassCount;
          this.createParam.realPay = card.valueMoney;
        }
      }
    },

    handleAudioUploadSuccess(res, file) {
      if (res.code != 20000) {
        messageUtils.errorMsg(this, res.message);
        return;
      }
      messageUtils.successMsg(this, "上传成功");
      let fileData = {
        fileName: file.name,
        filePath: res.data,
        uid: file.uid,
      };
      this.audioFileList.push(fileData);
    },

    handleAudioUploadRemove(file) {
      let id1 = this.audioFileList.findIndex((item) => {
        if (item.uid === file.uid) {
          return true;
        }
      });
      this.audioFileList.splice(id1, 1);
    },

    handleSearchUser() {
      let param = {
        phoneNumber: this.createParam.userPhone,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      findVipUser(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          this.createParam.user.name = "未搜到用户";
          return;
        }
        this.createParam.user = data;
      });
    },

    handleWord(wordType, tData) {
      //添加
      if (wordType == 1) {
        this.onCreate(tData);
      }
    },
    doRefreshWord(show, wordType) {
      this.wordType = wordType;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },

    onCreate(tData) {
      let param = tData;
      createUserByCard(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          this.initData();
          this.closeWordDlg();
          messageUtils.successMsg(this, response.message);
          this.show = false;
          this.$emit("onBtnOK");
        }
      });
    },
    closeWordDlg() {
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/BuyLessonCardDetail.vue